export default __webpack_public_path__ + "static/media/b4.a745de4b.webp";